import React, { useState, useEffect, useRef } from 'react'
import validator from 'validator'
import axios from 'axios'
import {
  BlueBoxContainer,
  TopTextContainer,
  TopIcon,
  TopText1,
  TopText2,
  EmbedContainer,
  ErrorContainer,
  FormWrapper,
  FormInputFields, 
  FormSubmitButton,
  FromField, 
  ToField,
  Icon1, Icon2, Icon3,
  FromInput,
  ToInput,
  EmailField,
  EmailInput,
  BottomTextContainer,
  BottomLeftText,
  BottomLeftLink,
  BottomRightText,
  BottomRightIcon,
  BottomRightLink
} from './style'

import { getAddress } from "../../utils"

const BOOKING_ROOT_APP = "https://jyst-booking.herokuapp.com"
// const BOOKING_ROOT_APP = "http://lvh.me:3000"
// https://medium.com/better-programming/the-best-practice-with-google-place-autocomplete-api-on-react-939211e8b4ce
let autoCompleteFrom;
let autoCompleteTo;

const loadScript = (url, callback) => {
  let script = document.createElement("script");
  script.type = "text/javascript";

  if (script.readyState) {
    script.onreadystatechange = function() {
      if (script.readyState === "loaded" || script.readyState === "complete") {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    script.onload = () => callback();
  }

  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
}

function handleScriptLoad(updateQuery, autoCompleteRef, field) {

  if(field === "from") {
    autoCompleteFrom = new window.google.maps.places.Autocomplete(
      autoCompleteRef.current,
      { componentRestrictions: { country: "uk" } }
    );

    autoCompleteFrom.setFields(["address_components", "formatted_address"]);
    autoCompleteFrom.addListener("place_changed", () =>
      handlePlaceSelect(updateQuery, autoCompleteFrom, field)
    );
  } else {
    autoCompleteTo = new window.google.maps.places.Autocomplete(
      autoCompleteRef.current,
      { componentRestrictions: { country: "uk" } }
    );

    autoCompleteTo.setFields(["address_components", "formatted_address"]);
    autoCompleteTo.addListener("place_changed", () =>
      handlePlaceSelect(updateQuery, autoCompleteTo, field)
    );
  }
}

async function handlePlaceSelect(updateQuery, autocompleteRef, field) {
  const address = autocompleteRef.getPlace()

  const { address_1, city, postcode, formatted_address } = getAddress(address)

  if (field === "from") {
    updateQuery({
      address_1,
      city,
      postcode, 
      formatted_address,
      type: "pickup"
    });
  } else {
    updateQuery({
      address_1,
      city, 
      postcode,
      formatted_address,
      type: "dropoff"
    })
  }

}

const EmbedQuote = () => {
  const [bookingsUrl, setBookingsUrl] = useState("")
  const [companyId, setCompanyId] = useState()

  const [collection, setCollection] = useState(null)
  const [delivery, setDelivery] = useState()
  const [email, setEmail] = useState()
  const [errors, setErrors] = useState()
  const [processing, setProcessing] = useState(false)

  const toRef = useRef(null)
  const fromRef = useRef(null)

  useEffect(() => {
    loadCompany()
    loadScript(
      `https://maps.googleapis.com/maps/api/js?key=AIzaSyAh6JdJQ98RdQwgi6Ey1swIoQ7cvHIyoko&libraries=places`,
      () => {
        handleScriptLoad(setCollection, fromRef, "from")
        handleScriptLoad(setDelivery, toRef, "to")
      }
    );
  }, [])

  const loadCompany = () => {
    setProcessing(true)
    console.log("BOOKING ROOT APP: ", BOOKING_ROOT_APP)
    let bookingOrigin = '';
    let embedElement = document.getElementById("jyst-booking-form");
    console.log("EMBED ELEMENT: ", embedElement);
    console.log("EMBED ELEMENT S: ", embedElement.dataset.companyUrl);
    console.log("ORIGIN: ", window.location.origin);
    //console.log("P ORIGIN: ", window.parent.location.origin);
    if(embedElement.dataset.companyUrl !== undefined) {
      bookingOrigin = embedElement.dataset.companyUrl.split("/embed.js")[0];
    } else if(window.location.origin != 'null') {
      bookingOrigin = window.location.origin;
    } else {
      bookingOrigin = window.parent.location.origin;
    }
    console.log("BOOKING ORIGIN: ", bookingOrigin);
    axios.get(`${BOOKING_ROOT_APP}/api/v1/company`, {
      params: {
        source: bookingOrigin.replace("//www.","//")
      }
    })
      .then((response) => {
        console.log('Company: ', response.data)
        const { bookings_url, company_id } = response.data
        setBookingsUrl(bookings_url)
        setCompanyId(company_id)
        setProcessing(false)
      })
      .catch((error) => {
        console.log('Error', error)
        setProcessing(false)
      })
  }

  const onSubmitQuote = () => {
    setProcessing(true)

    let from = collection
    let to = delivery

    if(!from) {
      from = {
        postcode: fromRef.current.value, 
        address_1: "",
        city: "",
        formatted_address: "",
        type: "pickup"
      }

      if(!fromRef.current.value) {
        setErrors("Pickup Postcode can't be blank!")
        setProcessing(false)
        return true
      }
    }

    if(!to) {
      to = {
        postcode: toRef.current.value,
        addres_1: "",
        city: "",
        formatted_address: "",
        type: "dropoff"
      }

      if (!toRef.current.value) {
        setErrors("Destination Postcode can't be blank!")
        setProcessing(false)
        return(true)
      }
    }

    if(!email) {
      setErrors("Email field can't be blank!")
      setProcessing(false)
      return 
    } else {
      setErrors(null)
    }

    // is email valid
    if(!validator.isEmail(email)) {
      setErrors("Email is not valid!")
      setProcessing(false)
      return
    } else {
      setErrors(null)
    }

    let allStops = [
      from, 
      to
    ]

    axios.post(`${bookingsUrl}/api/v1/companies/${companyId}/quotes`, {
      email,
      stops: allStops
    }).then((response) => {

      const { quote, error } = response.data

      if(quote) {
        window.top.location.href = `${bookingsUrl}/quote/step-2?quote=${quote.id}`
      } else {
        setCollection(null)
        setDelivery(null)
        setErrors(error)
      }

      setProcessing(false)
    }).catch((error) => {
      setErrors(error)
      setCollection(null)
      setDelivery(null)
      setProcessing(false)
    })

  }

  return (
    <BlueBoxContainer>
      
      <TopTextContainer>
        <TopIcon 
          src={`${BOOKING_ROOT_APP}/icons/dots.svg`}
        />
        <TopText1>Get a live quote</TopText1>
        <TopText2>- book in 3 easy steps: </TopText2>
        <TopText2>Use Full Postcodes</TopText2>
      </TopTextContainer>

      <EmbedContainer>
          <FormWrapper>
              <FormInputFields>
                <FromField>
                  <Icon1 
                    src={`${BOOKING_ROOT_APP}/icons/home-icon-1.svg`}
                  />
                  <FromInput 
                    type="text"
                    ref={fromRef}
                    placeholder="Pickup Postcode"
                    autoComplete="off"
                    onFocus={(e) => {
                      e.target.autocomplete = "from-foobarbaz"
                    }}
                  />
                </FromField>

                <ToField>
                  <Icon2 
                    src={`${BOOKING_ROOT_APP}/icons/home-icon-2.svg`}
                  />
                  <Icon3 
                    src={`${BOOKING_ROOT_APP}/icons/home-icon-3.svg`}
                  />
                  <ToInput 
                    type="text"
                    ref={toRef}
                    placeholder="Destination Postcode"
                    autoComplete="off"
                    onFocus={(e) => {
                      e.target.autocomplete = "to-foobarbaz"
                    }}
                  />
                </ToField>

                <EmailField>
                  <Icon1 
                    src={`${BOOKING_ROOT_APP}/icons/home-icon-4.svg`}
                  />
                  <EmailInput
                    type="email"
                    autoComplete="off"
                    placeholder="Your Email Address"
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="off"
                    onFocus={(e) => {
                      e.target.autocomplete = "email-foobarbaz"
                    }}
                  />
                </EmailField>
                
              </FormInputFields>


              <FormSubmitButton
                type="submit"          
                disabled={processing}
                value={processing ? "Building a Quote..." : "Get A Quote Online"}
                onClick={onSubmitQuote}
              />
          </FormWrapper>

          { errors && (
            <ErrorContainer>{ JSON.stringify(errors) }</ErrorContainer>
          )}
      </EmbedContainer>
            
      <BottomTextContainer>
        <BottomRightText>
            <BottomRightIcon
              src={`${BOOKING_ROOT_APP}/icons/line-icon.svg`}
            />
            Need multiple stops?
            <BottomRightLink 
              href={bookingsUrl}
              target="_blank"
            >
              Click here »
            </BottomRightLink>
        </BottomRightText>
      </BottomTextContainer>
    </BlueBoxContainer>
  )
}

export default EmbedQuote